/*
  Signature knife picker (snippets/signature-variant-picker.liquid): a row of handle swatches, each cut from that
  knife's handle close-up (view 04) with its price, and the chosen knife's "Handle + Blade" name ("Koa + Stainless
  Steel") above the row (Oct 14, 2026, audit UI/UX 3; the Oct 13 version was one dropdown with the same names).
  Picking a swatch sets the hidden Handle option select so the theme updates price, photos, SKU, specifications,
  URL and Add to cart. Loaded on every page (layout/theme.liquid) so it also works in quick view.
*/
(function () {
  function decode(text) {
    var el = document.createElement('textarea');
    el.innerHTML = text || '';
    return el.value;
  }

  function inStock(variant) {
    return variant.available;
  }

  // The theme binds its variant handling when it starts (it fires page:loaded when done).
  function whenThemeReady(callback) {
    if (window.theme && theme.sections) callback();
    else document.addEventListener('page:loaded', callback, { once: true });
  }

  // The swatch row. Markup cached from the Oct 13 dropdown version is rebuilt into the swatch layout.
  function swatchRow(root) {
    var row = root.querySelector('[data-sig-swatches]');
    if (row) return row;
    var select = root.querySelector('[data-sig-knife]');
    if (!select) return null;
    var field = select.closest('.sig-picker__field');
    var id = select.id || 'SigKnife';
    field.innerHTML =
      '<div class="label sig-picker__heading" id="' + id + '-label">Handle + Blade</div>' +
      '<p class="sig-picker__current" data-sig-current></p>' +
      '<div class="sig-swatches" data-sig-swatches role="radiogroup" aria-labelledby="' + id + '-label"></div>';
    row = field.querySelector('[data-sig-swatches]');
    row.dataset.name = id;
    return row;
  }

  function setup(root) {
    if (root.dataset.sigReady) return;
    root.dataset.sigReady = 'true';

    var master = root.querySelector('[data-variant-input]');
    var row = swatchRow(root);
    if (!row) return;
    var current = root.querySelector('[data-sig-current]');
    // Quick view adds "-modal" to every id, so the row points at its heading as it is now.
    var heading = root.querySelector('.sig-picker__heading');
    if (heading && heading.id) row.setAttribute('aria-labelledby', heading.id);

    var variants = JSON.parse(root.querySelector('[data-sig-variants]').textContent).map(function (variant) {
      variant.handle = decode(variant.handle) || variant.value.replace(/^Icon\s+/i, '').replace(/\s+-\s+\d+$/, '');
      variant.steel = decode(variant.steel);
      variant.blade = decode(variant.blade) || variant.steel;
      // Damasteel knives keep Blade Material "Damascus" but read "Damasteel" here (Dane, Oct 14, 2026).
      if (/damasteel/i.test(variant.steel)) variant.blade = 'Damasteel';
      variant.detail = decode(variant.detail);
      variant.liner = decode(variant.liner);
      variant.icon = /^Icon\s/i.test(variant.value);
      variant.number = (variant.sku || variant.value).slice(-2);
      variant.match = [variant.handle, variant.blade, variant.steel].join('|');
      return variant;
    });

    function twinsOf(variant) {
      return variants.filter(function (other) {
        return other !== variant && other.available && other.match === variant.match;
      });
    }

    // Every knife in stock is listed. A sold-out Icon is made again, so it stays listed (marked
    // sold out) unless a knife in stock has the same handle, blade and steel.
    var listed = variants.filter(function (variant) {
      return variant.available || (variant.icon && !twinsOf(variant).length);
    });

    // Knives with the same handle sit together, handles in variant order.
    var handles = [];
    listed.forEach(function (variant) {
      if (handles.indexOf(variant.handle) === -1) handles.push(variant.handle);
    });
    listed.sort(function (a, b) {
      return handles.indexOf(a.handle) - handles.indexOf(b.handle);
    });

    // "Handle + Blade". When knives would read the same, the steel is added if theirs differ, and
    // then, for knives that still match, the variant's Handle detail field, else its liner,
    // else its number.
    function others(variant, test) {
      return listed.some(function (other) {
        return other !== variant && test(other);
      });
    }
    listed.forEach(function (variant) {
      if (others(variant, function (other) { return other.match === variant.match; })) {
        variant.note = variant.detail || (variant.liner ? variant.liner + ' liner' : '') || 'No. ' + variant.number;
      }
    });
    listed.forEach(function (variant) {
      var notes = [];
      var steelDiffers = others(variant, function (other) {
        return other.handle === variant.handle && other.blade === variant.blade && other.steel !== variant.steel;
      });
      if (steelDiffers && variant.steel !== variant.blade) notes.push(variant.steel);
      if (variant.note) {
        var clash = others(variant, function (other) {
          return other.match === variant.match && other.note === variant.note;
        });
        notes.push(clash ? variant.note + ', No. ' + variant.number : variant.note);
      }
      variant.label = variant.handle + ' + ' + variant.blade + (notes.length ? ' (' + notes.join(', ') + ')' : '');
      if (!variant.available) variant.label += ' (sold out)';
    });

    function shown() {
      return variants.find(function (variant) {
        return variant.value === master.value;
      });
    }

    // One swatch per listed knife: the handle photo (a plain circle when there's none), the Icon tag, the price.
    // No stock counts (Dane, Oct 14, 2026).
    function build() {
      row.innerHTML = '';
      listed.forEach(function (knife) {
        var swatch = document.createElement('label');
        swatch.className = 'sig-swatch text-label' + (knife.available ? '' : ' sig-swatch--sold-out');
        swatch.title = knife.label;

        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'sig-swatch__input';
        input.name = row.dataset.name;
        input.value = knife.value;
        input.setAttribute('aria-label', knife.label + (knife.icon ? ', Icon' : '') + (knife.price ? ', ' + knife.price : ''));

        var photo = document.createElement('span');
        photo.className = 'sig-swatch__photo';
        if (knife.swatch) {
          var img = document.createElement('img');
          img.src = knife.swatch;
          img.alt = '';
          img.width = 52;
          img.height = 52;
          photo.append(img);
        }
        if (knife.icon) {
          var tag = document.createElement('span');
          tag.className = 'sig-swatch__tag';
          tag.textContent = 'Icon';
          photo.append(tag);
        }

        var price = document.createElement('span');
        price.className = 'sig-swatch__price';
        price.textContent = knife.price || '';

        swatch.append(input, photo, price);
        row.append(swatch);
      });
    }

    function mark(variant) {
      if (current) current.textContent = variant.label;
      row.querySelectorAll('.sig-swatch__input').forEach(function (input) {
        input.checked = input.value === variant.value;
        input.parentNode.classList.toggle('sig-swatch--current', input.checked);
      });
    }

    function choose(variant) {
      mark(variant);
      if (master.value === variant.value) return;
      master.value = variant.value;
      master.dispatchEvent(new Event('change', { bubbles: true }));
    }

    row.addEventListener('change', function (evt) {
      var variant = listed.find(function (knife) {
        return knife.value === evt.target.value;
      });
      if (variant) choose(variant);
    });

    build();

    var start = shown();
    if (start && listed.indexOf(start) > -1) {
      mark(start);
      return;
    }

    // Opened on a knife that isn't listed (?variant=… of a sold-out knife): move to an in-stock knife
    // with the same handle, blade and steel, else the first in-stock knife with photos, else the
    // first in-stock knife. Photos first in each case.
    var twins = start ? twinsOf(start) : [];
    var stocked = variants.filter(inStock);
    var replacement =
      twins.find(function (variant) {
        return variant.photos;
      }) ||
      twins[0] ||
      stocked.find(function (variant) {
        return variant.photos;
      }) ||
      stocked[0];
    if (!replacement) return;
    mark(replacement);
    whenThemeReady(function () {
      choose(replacement);
    });
  }

  function setupAll() {
    document.querySelectorAll('[data-sig-picker]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll);
  else setupAll();
  document.addEventListener('quickview:loaded', setupAll);
  document.addEventListener('shopify:section:load', setupAll);
})();
